// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.VendorOfferItem')
class Orders__VendorOfferItem {
    @jsonProperty(() => Orders__VendorOfferItem.Id)
    id: Orders__VendorOfferItem.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "requestItem", "requestItemId", "quantities", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "requestItem", "requestItemId", "quantities", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "offer", "offerId", "requestItem", "requestItemId", "quantities", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "offer": "Orders.VendorOffer", "offerId": "Orders.VendorOffer.Id", "requestItem": "Orders.CustomerRequestItem", "requestItemId": "Orders.CustomerRequestItem.Id", "quantities": "Orders.VendorOfferItemQuantity[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ offer: () => Orders.VendorOffer, requestItem: () => Orders.CustomerRequestItem } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ quantities: () => Orders.VendorOfferItemQuantity } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θoffer = Signals.proxySignalDeferred<Orders.VendorOffer>(() => (undefined) as any);
    private readonly θofferId = Signals.proxySignalDeferred<Orders.VendorOffer.Id>(() => (undefined) as any);
    private readonly θrequestItem = Signals.proxySignalDeferred<Orders.CustomerRequestItem>(() => (undefined) as any);
    private readonly θrequestItemId = Signals.proxySignalDeferred<Orders.CustomerRequestItem.Id>(() => (undefined) as any);
    private readonly θquantities = Signals.proxySignalDeferred<Orders.VendorOfferItemQuantity[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.VendorOfferItem' {
        return 'Orders.VendorOfferItem'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.VendorOfferItem' {
        return 'Orders.VendorOfferItem'
    }

    static get __baseType(): 'Orders.VendorOfferItem' {
        return 'Orders.VendorOfferItem'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.VendorOfferItem' {
        return 'Orders.VendorOfferItem'
    }

    get [BoInfoSymbol]() {
        return Orders__VendorOfferItem[BoInfoSymbol]
    }

    get offer(): Orders.VendorOffer {
        return this.θoffer?.()
    }

    set offer(offer) {
        this.θoffer.set(coerceDataType(offer, Orders.VendorOffer, false, true))
        if (offer) {
            this.θofferId.set(offer.id)
        } else if (offer === null && offer) {
            this.θofferId.set(null)
        }
    }

    get offerId(): Orders.VendorOffer.Id {
        return this.θofferId?.()
    }

    set offerId(offerId) {
        if (offerId === null) this.θoffer.set(null)
        if (this.offer?.id && offerId != this.offer.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θofferId.set(coerceDataType(offerId, 'Orders.VendorOffer.Id', false, true))
    }

    get requestItem(): Orders.CustomerRequestItem {
        return this.θrequestItem?.()
    }

    set requestItem(requestItem) {
        this.θrequestItem.set(coerceDataType(requestItem, Orders.CustomerRequestItem, false, true))
        if (requestItem) {
            this.θrequestItemId.set(requestItem.id)
        } else if (requestItem === null && requestItem) {
            this.θrequestItemId.set(null)
        }
    }

    get requestItemId(): Orders.CustomerRequestItem.Id {
        return this.θrequestItemId?.()
    }

    set requestItemId(requestItemId) {
        if (requestItemId === null) this.θrequestItem.set(null)
        if (this.requestItem?.id && requestItemId != this.requestItem.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestItemId.set(coerceDataType(requestItemId, 'Orders.CustomerRequestItem.Id', false, true))
    }

    get quantities(): Orders.VendorOfferItemQuantity[] {
        return this.θquantities?.()
    }

    set quantities(quantities) {
        this.θquantities.set(coerceDataType(quantities, Orders.VendorOfferItemQuantity, true, true))
        this.quantities?.forEach?.(item => { if (item && "item" in item) item.item = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__VendorOfferItem>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                quantities: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__VendorOfferItem()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__VendorOfferItem>, restrictToClass?: Class<Partial<Orders__VendorOfferItem>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('offer', 'offerId', 'requestItem', 'requestItemId', 'quantities', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    getQuantity(quantity: number): This.VendorOfferItemQuantity {
        return this.quantities.find(q => q.quantity == quantity)
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__VendorOfferItem {
        return equal(this, other)
    }
}

namespace Orders__VendorOfferItem { }

export import VendorOfferItem = Orders__VendorOfferItem
setTimeout(() => {
    jsonProperty(() => Orders.VendorOffer)(Orders__VendorOfferItem.prototype, 'offer')
    jsonProperty(() => Orders.VendorOffer.Id)(Orders__VendorOfferItem.prototype, 'offerId')
    jsonProperty(() => Orders.CustomerRequestItem)(Orders__VendorOfferItem.prototype, 'requestItem')
    jsonProperty(() => Orders.CustomerRequestItem.Id)(Orders__VendorOfferItem.prototype, 'requestItemId')
    jsonArrayProperty(() => Orders.VendorOfferItemQuantity)(Orders__VendorOfferItem.prototype, 'quantities')
    jsonProperty(() => Date)(Orders__VendorOfferItem.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItem.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__VendorOfferItem.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItem.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__VendorOfferItem.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItem.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__VendorOfferItem.prototype, 'versionNumber')
})

export const VendorOfferItemθId = Number;

export type VendorOfferItemθId = number;

namespace Orders__VendorOfferItem {
    export type Id = NominalType<number, 'Orders.VendorOfferItem'>

}
